var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_722_6539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.332 20.5C10.332 14.9772 14.8092 10.5 20.332 10.5H30.332C35.8549 10.5 40.332 14.9772 40.332 20.5V40.5H20.332C14.8092 40.5 10.332 36.0228 10.332 30.5V20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_6539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6852 22.0227C30.7789 22.1164 30.832 22.243 30.832 22.3758V32.0117C30.832 32.2883 30.6086 32.5117 30.332 32.5117H20.332C20.0555 32.5117 19.832 32.2883 19.832 32.0117V19.0117C19.832 18.7352 20.0555 18.5117 20.332 18.5117H26.968C27.1008 18.5117 27.2289 18.5648 27.3227 18.6586L30.6852 22.0227ZM29.6789 22.6055L26.7383 19.6648V22.6055H29.6789ZM22.332 25.043C22.2989 25.043 22.2671 25.0561 22.2436 25.0796C22.2202 25.103 22.207 25.1348 22.207 25.168V25.918C22.207 25.9511 22.2202 25.9829 22.2436 26.0064C22.2671 26.0298 22.2989 26.043 22.332 26.043H28.332C28.3652 26.043 28.397 26.0298 28.4204 26.0064C28.4439 25.9829 28.457 25.9511 28.457 25.918V25.168C28.457 25.1348 28.4439 25.103 28.4204 25.0796C28.397 25.0561 28.3652 25.043 28.332 25.043H22.332ZM22.332 27.168C22.2989 27.168 22.2671 27.1811 22.2436 27.2046C22.2202 27.228 22.207 27.2598 22.207 27.293V28.043C22.207 28.0761 22.2202 28.1079 22.2436 28.1314C22.2671 28.1548 22.2989 28.168 22.332 28.168H25.207C25.2402 28.168 25.272 28.1548 25.2954 28.1314C25.3189 28.1079 25.332 28.0761 25.332 28.043V27.293C25.332 27.2598 25.3189 27.228 25.2954 27.2046C25.272 27.1811 25.2402 27.168 25.207 27.168H22.332Z",
    fill: "url(#paint0_linear_722_6539)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_722_6539",
    x: 0.332031,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_722_6539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_722_6539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_6539",
    x1: 25.332,
    y1: 18.5117,
    x2: 25.332,
    y2: 32.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA1515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6539"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.332 25.5117C17.332 21.0934 20.9138 17.5117 25.332 17.5117C29.7503 17.5117 33.332 21.0934 33.332 25.5117V33.5117H25.332C20.9138 33.5117 17.332 29.93 17.332 25.5117Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.c3abc9a771ad881b39f86906ac70b326.svg";
export { ForwardRef as ReactComponent };